import { drupalComponent } from '@nech/src/helpers/drupal-component';

(function (Drupal, $) {
  drupalComponent('image', {
    selector: '[data-nech-image]',

    shared: {
      findRatioImage: function (imageStyle: string) {
        switch (imageStyle) {
          case '16_9':
            return 'aspect-ratio: 16 / 9';
          case '1_1':
            return 'aspect-ratio: 1 / 1';
          default:
            return 'aspect-ratio: 1 / 1';
        }
      },
    },

    attach(context, options) {
      const $el = $(this.selector, context);
      const self = this;
      $el
        .filter(function () {
          if ($(this).data('image-once-attached')) return false;
          $(this).data('image-once-attached', true);
          return true;
        })
        .each(function () {
          const $wrapper = $(this);
          const $img = $wrapper.find('img');
          const $placeholder = $wrapper.find('svg');

          function handleImageLoad() {
            $img.css('opacity', '1');
            $placeholder.css('opacity', '0');
          }

          function handleImageError() {
            const altText = $img.attr('alt');
            if (!$img.hasClass('fallback-loaded')) {
              const ratioImageDefined = self.shared.findRatioImage($img.data('image-style'));
              $img.attr('style', ratioImageDefined);
              $img.addClass('fallback-loaded');
              $img.attr('src', '/themes/custom/nech/src/assets/images/image-not-found.png');
              $img.attr('srcset', '/themes/custom/nech/src/assets/images/image-not-found.png');
              $img.css('opacity', '1');
              $placeholder.css('opacity', '0');
              $img.after(altText ? `<span aria-hidden="true">${altText}</span>` : '');
            }
          }

          if ($img[0]?.complete) {
            if ($img[0].naturalWidth === 0) {
              handleImageError();
            } else {
              handleImageLoad();
            }
          } else {
            $placeholder.css('opacity', '1');
            $img.css('opacity', '0');
            $img.on('load', handleImageLoad);
            $img.on('error', handleImageError);
          }
        });
    },
  });
})(Drupal, jQuery);
